import { render, staticRenderFns } from "./cookiepolicy.vue?vue&type=template&id=92a5e320&scoped=true"
import script from "./cookiepolicy.vue?vue&type=script&lang=js"
export * from "./cookiepolicy.vue?vue&type=script&lang=js"
import style0 from "./cookiepolicy.vue?vue&type=style&index=0&id=92a5e320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a5e320",
  null
  
)

export default component.exports